import { sniff, history } from '@/util'
import userAppLogin from './bridge/userAppLogin'

// 抹平三端登录，回掉函数中返回的数据如下
// token 登录态
// isLogin 是否登录
const userLogin = async(callback) => {
  if (sniff.isUboxApp) {
    userAppLogin(callback)
  } else if ( sniff.isWechatMiniProgram ) {
    window.wx.miniProgram.navigateTo({
      url: '/pages/auth/auth',
    })
  } else {
    // window.location.href = '#/login'
    history.push('/login')
  }
}

export default userLogin